// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rIFb","type":"styles_type__IMUKQ","choices":"styles_choices__2PLbz"};